import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIssueKey } from '@atlassian/jira-issue-context-service/src/main.tsx';
import {
	useProjectKey,
	useProjectType,
} from '@atlassian/jira-project-context-service/src/main.tsx';
import { useProjectPermissions } from '@atlassian/jira-project-permissions-service/src/main.tsx';

export const useIsJourneyViewerEnabled = (): boolean => {
	const issueKey = useIssueKey();
	const projectKey = useProjectKey(issueKey);
	const [{ canEditIssues }] = useProjectPermissions(projectKey);
	const projectType = useProjectType(projectKey);
	const isServiceDeskProject = projectType === SERVICE_DESK_PROJECT;

	return isServiceDeskProject && canEditIssues && fg('jsm-journey-builder-m1');
};
